
const shingsouIotMoudle={
  namespaced: true,
  state:{
    searchIccid:''
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default shingsouIotMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/shingsouIot.js